module.exports = __webpack_public_path__ + "img/facebook-icon-dark.b2a6eb02.svg";